import { render, staticRenderFns } from "./SquareDetail.vue?vue&type=template&id=ce7a6ae8&scoped=true&"
import script from "./SquareDetail.vue?vue&type=script&lang=js&"
export * from "./SquareDetail.vue?vue&type=script&lang=js&"
import style0 from "./SquareDetail.vue?vue&type=style&index=0&id=ce7a6ae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7a6ae8",
  null
  
)

export default component.exports